import { render, staticRenderFns } from "./Floors.vue?vue&type=template&id=f829e5bc&scoped=true"
import script from "./Floors.vue?vue&type=script&lang=js"
export * from "./Floors.vue?vue&type=script&lang=js"
import style0 from "./Floors.vue?vue&type=style&index=0&id=f829e5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f829e5bc",
  null
  
)

export default component.exports